<template>
  <div class="home">
    <Loader v-show="lodingShow"></Loader>
    <Header></Header>
    <div class="WeChat-binding" v-show="wxHotels">
      <div class="binding-box">
        <div class="binding">
          <div class="binding-header">账号绑定</div>
          <div class="binding-content">
            <p class="binding-content-title">绑定您的登录账号</p>
            <div class="normal-item">
              <div class="err" v-show="WeChatData.account.err">
                <i class="err-icon"></i>
                <span>{{ WeChatData.account.msg }}</span>
              </div>
              <div
                class="clearInput"
                v-show="WeChatData.account.text != ''"
                @click="clearInput('wxinputName')"
              ></div>
              <input
                type="text"
                class="name-icon"
                ref="wxInputName"
                :class="WeChatData.account.err ? 'input-err' : ''"
                placeholder="请输入您的账号"
                v-model="WeChatData.account.text"
                @focus="wechatNameFouse"
                @blur="wechatNameBlur"
              />
            </div>
            <div class="normal-item" v-if="!WeChatData.proclaimedInWriting">
              <div class="err" v-show="WeChatData.password.err">
                <i class="err-icon"></i>
                <span>{{ WeChatData.password.msg }}</span>
              </div>
              <div
                class="clearInput wxBindclearInput"
                v-show="WeChatData.password.code != ''"
                @click="clearInput('wxInputPwd')"
              ></div>
              <div class="proclaimed-iocn" @click="wxBindProclained"></div>
              <input
                type="password"
                class="password-icon"
                :class="WeChatData.password.err ? 'input-err' : ''"
                placeholder="请输入域密码/PMS密码/首旅密码"
                v-model="WeChatData.password.code"
                @focus="wechatNamePwdFouse"
                @blur="wechatNamePwdBlur"
              />
            </div>
            <div class="normal-item" v-else>
              <div class="err" v-show="WeChatData.password.err">
                <i class="err-icon"></i>
                <span>{{ WeChatData.password.msg }}</span>
              </div>
              <div
                class="clearInput wxBindclearInput"
                v-show="WeChatData.password.code != ''"
                @click="clearInput('wxInputPwd')"
              ></div>
              <div class="pwdtag-iocn" @click="wxBindProclained"></div>
              <input
                type="text"
                class="password-icon"
                :class="WeChatData.password.err ? 'input-err' : ''"
                placeholder="请输入域密码/PMS密码/首旅密码"
                v-model="WeChatData.password.code"
                @focus="wechatNamePwdFouse"
                @blur="wechatNamePwdBlur"
              />
            </div>

            <div
              class="hotel normal-item"
              v-show="selectHotel != null && wxHotels"
              @click="onChangePullDown"
            >
              <div
                class="clearInput"
                v-show="HotelInputKye != ''"
                @click="clearInput('wxInputHotelInputKye')"
              ></div>
              <input
                type="text"
                class="hotel-icon"
                placeholder="请搜索/选择门店"
                :value="HotelInputKye"
                v-on:input="searchHotels"
              />
              <div
                class="hotel-list"
                v-show="loginMethod.isPullDownHotel && wxHotels"
              >
                <ul>
                  <li
                    v-for="(hotel, i) in Hotels"
                    :key="i"
                    class="hotel-list-item"
                    @click.stop="checkedHotel(hotel)"
                  >
                    <span>{{ hotel && hotel.HotelCd }}</span>
                    {{ hotel && hotel.HotelName }}
                  </li>
                </ul>
              </div>
            </div>
            <button
              class="btn-click"
              ref="webChatBnClick"
              @click="webChatBnClick()"
              @keyup.enter="webChatBnClick()"
            >
              绑定账号
            </button>
            <button
              class="interlinkage"
              style="width: 100%"
              @click="nextPageTage"
            >
              使用其他方式登录>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="content-warp">
      <DefaultCarousel v-if="imgList.length <= 1" :imgList="imgList" />
      <Carousel v-if="imgList.length >= 2" :imgList="imgList" />
      <form
        class="login"
        onsubmit="{return false}"
        @click.self.prevent="exclusive"
      >
        <div class="login-warp" v-show="!wxHotels">
          <div
            class="normal-landing"
            v-if="!loginMethod.sweepTheLoginCode"
            @click.self.prevent="exclusive"
          >
            <!-- 切换扫码登录 -->
            <div
              class="normal-loding-btn"
              v-if="CheckWhetherThirdPartyLoggedIn"
              @click="onSweepTheLoginCode"
            ></div>
            <div class="normal-table">
              <div
                class="tabbtn"
                :class="loginMethod.isOnWay ? 'active' : ''"
                @click="onTrigger"
              >
                账号密码登录
              </div>
              <span v-if="loginMethodSwitch.indexOf(2) != -1"></span>
              <div
                v-if="loginMethodSwitch.indexOf(2) != -1"
                class="tabbtn"
                :class="loginMethod.isOnWay ? '' : 'active'"
                @click="onTrigger"
              >
                验证码登录
              </div>
            </div>
            <div class="normal-content">
              <!-- 普通登录  -->
              <div class="normal-item" v-show="loginMethod.isOnWay">
                <div class="err" v-show="formData.account.account.err">
                  <i class="err-icon"></i>
                  <span v-cloak>{{ formData.account.account.msg }}</span>
                  <!-- <router-link
                    :to="{ name: 'Retrieve' }"
                    v-show="resetpasswords9"
                    >立即修改</router-link
                  > -->
                  <a :href="resetpasswordsurl" v-show="resetpasswords9"
                    >立即修改</a
                  >
                </div>
                <div
                  class="clearInput"
                  v-show="formData.account.account.close"
                  @click="clearInput('inputName')"
                ></div>
                <input
                  type="text"
                  class="name-icon"
                  ref="inputNameRef"
                  :class="formData.account.account.err ? 'input-err' : ''"
                  placeholder="请输入您的账号"
                  v-model="formData.account.account.text"
                  @focus="nameFouse"
                  @input="nameFouse"
                  @blur="nameBlur"
                />
              </div>
              <div
                class="normal-item"
                v-show="loginMethod.isOnWay && !inscriptions"
                @keyup.enter="btnClick()"
              >
                <div class="err" v-show="formData.account.password.err">
                  <i class="err-icon"></i>
                  <span>{{ formData.account.password.msg }}</span>
                </div>
                <div
                  style="right: 34px"
                  class="clearInput"
                  v-show="formData.account.password.close"
                  @click="clearInput('inputPwdt')"
                ></div>
                <div
                  class="proclaimed-iocn"
                  @click="passwordInscriptions"
                ></div>
                <input
                  type="password"
                  class="password-icon"
                  ref="inputPwdReft"
                  :class="formData.account.password.err ? 'input-err' : ''"
                  placeholder="请输入域密码/PMS密码/首旅密码"
                  v-model="formData.account.password.code"
                  @focus="namePwdFouse"
                  @input="namePwdFouse"
                  @blur="namePwdBlur"
                />
              </div>
              <div
                class="normal-item"
                v-show="loginMethod.isOnWay && inscriptions"
                @keyup.enter="btnClick()"
              >
                <div class="err" v-show="formData.account.password.err">
                  <i class="err-icon"></i>
                  <span>{{ formData.account.password.msg }}</span>
                </div>
                <div
                  style="right: 34px"
                  class="clearInput"
                  v-show="formData.account.password.close"
                  @click="clearInput('inputPwd')"
                ></div>
                <div class="pwdtag-iocn" @click="passwordInscriptions"></div>
                <input
                  type="text"
                  class="password-icon"
                  ref="inputPwdRef"
                  :class="formData.account.password.err ? 'input-err' : ''"
                  placeholder="请输入域密码/PMS密码/首旅密码"
                  v-model="formData.account.password.code"
                  @focus="namePwdFouse"
                  @input="namePwdFouse"
                  @blur="namePwdBlur"
                />
              </div>
              <!-- 验证吗登录  -->
              <div class="normal-item" v-show="!loginMethod.isOnWay">
                <div class="err" v-show="formData.cellPhone.phone.err">
                  <i class="err-icon"></i>
                  <span>{{ formData.cellPhone.phone.msg }}</span>
                </div>
                <div
                  class="clearInput"
                  v-show="formData.cellPhone.phone.close"
                  @click="clearInput('inputPhone')"
                ></div>
                <input
                  type="tel"
                  class="phone-icon"
                  ref="inputPhoneRef"
                  :class="formData.cellPhone.phone.err ? 'input-err' : ''"
                  placeholder="请输入您的手机号"
                  v-model="formData.cellPhone.phone.text"
                  @focus="phoneFouse"
                  @input="phoneFouse"
                  @blur="phoneBlur"
                />
              </div>
              <div
                class="normal-item normal-phone-code"
                v-show="!loginMethod.isOnWay"
                @keyup.enter="btnClick()"
              >
                <div class="err" v-show="formData.cellPhone.mobileCode.err">
                  <i class="err-icon"></i>
                  <span>{{ formData.cellPhone.mobileCode.msg }}</span>
                </div>
                <div
                  style="left: 150px"
                  class="clearInput"
                  v-show="formData.cellPhone.mobileCode.close"
                  @click="clearInput('inputPhoneCode')"
                ></div>
                <input
                  type="text"
                  class="password-icon"
                  ref="inputPhoneCodeRef"
                  placeholder="请输入短信验证码"
                  v-model="formData.cellPhone.mobileCode.code"
                  @focus="phoneCodeFouse"
                  @input="phoneCodeFouse"
                  @blur="phoneCodeBlur"
                />
                <button
                  class="normal-phone-code-button"
                  @click="getMobileCode()"
                >
                  {{ getMobileCodeText() }}
                </button>
              </div>

              <div
                class="hotel normal-item"
                v-show="selectHotel != null && !wxHotels"
                @click="onChangePullDown"
              >
                <div
                  class="clearInput"
                  v-show="HotelInputKye != ''"
                  @click="clearInput('inputHotelAcaear')"
                ></div>
                <input
                  type="text"
                  class="hotel-icon"
                  ref="nameHotelListRef"
                  placeholder="请搜索/选择门店"
                  :value="HotelInputKye"
                  v-on:input="searchHotels"
                />
                <div class="hotel-list" v-show="loginMethod.isPullDownHotel">
                  <ul>
                    <li
                      v-for="(hotel, i) in Hotels"
                      :key="i"
                      class="hotel-list-item"
                      @click.stop="checkedHotel(hotel)"
                    >
                      <span>{{ hotel && hotel.HotelCd }}</span>
                      {{ hotel && hotel.HotelName }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <button
              class="btn-click"
              v-focus
              ref="nameLogin"
              @click="btnClick()"
              @keyup.enter="btnClick()"
            >
              登录
            </button>
            <!-- <Geet :isGeet="isgt" @geetPath="GeetPath" @clickChange="GeetChange"></Geet> -->
            <component
              :is="currentCom"
              :isGeet="isgt"
              @geetPath="GeetPath"
              @clickChange="GeetChange"
            ></component>
            <a href="##" class="interlinkage"></a>
            <button class="interlinkage" @click="nextPage">忘记密码</button>
          </div>
          <div class="code-login" v-if="loginMethod.sweepTheLoginCode">
            <button
              class="normal-loding-btn code-login-btn"
              @click="onSweepTheLoginCode"
            >
              <!-- 切换扫码登录 -->
            </button>
            <div class="code-login-title">
              <button
                v-if="loginMethodSwitch.indexOf(3) != -1"
                v-bind:class="[
                  wexingType.type == 3 ? wexingType.activeCalss : ''
                ]"
                @click="onChengeWexinType(3)"
              >
                微信扫码登录
              </button>
              <button
                v-if="loginMethodSwitch.indexOf(4) != -1"
                v-bind:class="[
                  wexingType.type == 4 ? wexingType.activeCalss : ''
                ]"
                @click="onChengeWexinType(4)"
              >
                企业微信登录
              </button>
              <button
                v-if="loginMethodSwitch.indexOf(6) != -1"
                v-bind:class="[
                  wexingType.type == 6 ? wexingType.activeCalss : ''
                ]"
                @click="onChengeWexinType(6)"
              >
                钉钉扫码登录
              </button>
              <button
                v-if="loginMethodSwitch.indexOf(9) != -1"
                v-bind:class="[
                  wexingType.type == 9 ? wexingType.activeCalss : ''
                ]"
                @click="onChengeWexinType(9)"
              >
                飞书扫码登陆
              </button>
            </div>
            <!-- <p class="code-login-hint">
            请使用
            <span>微信APP</span> 扫码登
          </p>-->
            <!--  二维码 宽度170px  top 44px-->
            <div v-if="loginMethod.wx">
              <wxlogin
                v-if="
                  wexingType.type == 3 && loginMethodSwitch.indexOf(3) != -1
                "
                class="qr-code-warp"
                appid="wx995a2b8eb7638457"
                scope="snsapi_login"
                redirect_uri="https://newsso.bthhotels.com/AccountLogin/WxBack"
                :state="`${wxstate}_wx`"
                href="'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6MjIwcHg7bWFyZ2luLXRvcDoyMHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIyMHB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA=='"
              ></wxlogin>
              <WwLogin
                v-if="
                  wexingType.type == 4 && loginMethodSwitch.indexOf(4) != -1
                "
                :state="wxstate"
              />
              <!-- <WwLogin :state="wxstate" /> -->
              <Dingtalk
                v-if="
                  wexingType.type == 6 && loginMethodSwitch.indexOf(6) != -1
                "
                :state="wxstate"
              ></Dingtalk>
              <FlyBook
                v-if="
                  wexingType.type == 9 && loginMethodSwitch.indexOf(9) != -1
                "
                :state="wxstate"
              ></FlyBook>
            </div>
            <!-- v-if="!loginMethod.wx" -->
            <div class="weix-hotel" v-show="wxHotelsShow">
              <div class="hotel normal-item" @click="onChangePullDown">
                <div
                  class="clearInput"
                  v-show="HotelInputKye != ''"
                  @click="clearInput('inputHotelAcaear')"
                ></div>
                <input
                  type="text"
                  class="hotel-icon"
                  placeholder="请搜索/选择门店"
                  :value="HotelInputKye"
                  :state="wxstate"
                  v-on:input="searchHotels"
                />
                <div
                  class="hotel-list"
                  v-show="loginMethod.isPullDownHotel && wxHotelsShow"
                >
                  <ul>
                    <li
                      v-for="(hotel, i) in Hotels"
                      :key="i"
                      class="hotel-list-item"
                      @click.stop="checkedHotel(hotel)"
                    >
                      <span>{{ hotel && hotel.HotelCd }}</span>
                      {{ hotel && hotel.HotelName }}
                    </li>
                  </ul>
                </div>
              </div>
              <button
                class="btn-click"
                ref="wxlongBtn"
                @click="btnClick()"
                @keyup.enter="btnClick()"
              >
                登录
              </button>
            </div>
            <!-- <Geet :isGeet="isgt" @geetPath="GeetPath" @clickChange="GeetChange"></Geet> -->
            <component
              :is="currentCom"
              :isGeet="isgt"
              @geetPath="GeetPath"
              @clickChange="GeetChange"
            ></component>
          </div>
        </div>
      </form>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
// import funHelper from "lodash/function";
// import _ from "lodash";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import Loader from "@/components/Loader.vue";
import Carousel from "./carousel.vue";
import DefaultCarousel from "./defaultCarousel.vue";
import Geet from "../Geet.vue";
// const Home = () => import(/* webpackChunkName: 'geetComm' */ "../Geet.vue");
import wxlogin from "vue-wxlogin";
import WwLogin from "../../components/WwLogin/WwLogin.vue";
import Dingtalk from "../../components/Dingtalk";
import FlyBook from "../../components/FlyBook/FlyBook.vue"
import { isCellPhoneNumber } from "../../common/utils";
import staticUrl from "@/assets/img/bg.png";
const defaultUrl = staticUrl;
export default {
  name: "PcLogIn",
  components: {
    Header,
    Footer,
    Loader,
    Carousel,
    DefaultCarousel,
    Geet,
    wxlogin,
    WwLogin,
    Dingtalk,
    FlyBook
  },
  data: function() {
    return {
      loginMethodSwitch: [1], // 竖线分割 1=密码登入 2=短信登入 3=个人微信 4=企微登入 6=钉钉登入
      imgList: [
        {
          // ImgUrl: defaultUrl,
          ImgUrl: "",
          Href: ""
        }
      ],
      currentCom: "",
      resetpasswords9: false,
      resetpasswordsurl: "",
      inscriptions: false, // 密码明文切花
      lodingShow: false,
      UserId: "", //  当 隐藏域的 LoginType 不等于 0 时 是微信登陆
      OpenId: "", //  当 隐藏域的 LoginType 不等于 0 时 是微信登陆
      Code: "", //  当 隐藏域的 LoginType 不等于 0 时 是微信登陆
      ReturnUrl: "",
      LoginType: 0, // 微信绑定 状态下使用
      wxstate: "",
      wxHotels: false,
      wxHotelsShow: false,
      token: "",
      btnIsGt: false, // 是否显示验证码 在酒店列表接口  isError =true
      // loginErrorNumber: 0, // 记录 登陆错误次数
      isgt: false, // 显示 图形验证
      loginMethod: {
        // 登录方式
        sweepTheLoginCode: false, // 扫码登录
        isOnWay: true, // 登录 方式 true:普通登录   false:验证吗登录
        isPullDownHotel: false, // 酒店列表
        wx: true
      },
      wexingType: {
        type: 4,
        activeCalss: "active"
      },
      formData: {
        // 登录 验证
        account: {
          account: {
            text: "",
            oldText: "",
            close: false,
            err: false,
            msg: "请输入您的账号"
          },
          password: {
            code: "",
            err: false,
            close: false,
            msg: "请输入域密码/PMS密码/首旅密码"
          }
        },
        cellPhone: {
          phone: {
            text: "",
            close: false,
            err: false,
            msg: "请输入您的手机号"
          },
          mobileCode: {
            code: "",
            close: false,
            err: false,
            msg: "请输入短信验证码"
          },
          wait_timer: false
        }
      },
      WeChatData: {
        proclaimedInWriting: false, // 是否明文
        account: {
          text: "",
          oldText: "",
          close: false,
          err: false,
          msg: "请输入您的账号"
        },
        password: {
          code: "",
          close: false,
          err: false,
          msg: "请输入域密码/PMS密码/首旅密码"
        }
      }, // 绑定微信
      timer_interval: null,
      timer_timeout: null,
      HotelInputKye: "",
      isHotelsLoading: true, // 加载酒店 Loding 后期优化
      selectHotel: null,
      seldectHoteBackups: null, // 酒店拷贝
      Hotels: [], //
      isHotels: false // 是否加载过酒店列表的方法
    };
  },
  computed: {
    CheckWhetherThirdPartyLoggedIn: function() {
      const isWX = this.loginMethodSwitch.indexOf(3) != -1;
      const isQyWX = this.loginMethodSwitch.indexOf(4) != -1;
      const isDD = this.loginMethodSwitch.indexOf(6) != -1;
      const fyBook = this.loginMethodSwitch.indexOf(9) != -1;
      return isWX || isQyWX || isDD || fyBook;
    }
  },
  methods: {
    // 绑定微信  密码 明文切换
    wxBindProclained: function() {
      this.WeChatData.proclaimedInWriting = !this.WeChatData
        .proclaimedInWriting;
    },
    getHomeImgList: function() {
      const restImgs = this.$http.getByThePictureImgs();
      restImgs
        .then(res => {
          if (Number(res.Code) === 200 && res.Data.Banners.length > 0) {
            this.imgList = res.Data.Banners;
          } else {
            console.warn(
              `首页轮播接口未返回数据或返回值为空:Banners:{imgUrl:url,Href:url}[]:${res.Data.Banners.length}`
            );
          }
        })
        .catch(function(e) {
          console.warn(e);
        });
    },

    onSubmit: function(e) {
      return false;
    },

    // 微信登陆  切问下登陆 切换
    onChengeWexinType: function(type) {
      console.log(type)
      this.wexingType.type = type;
    },

    // 密码明文切换
    passwordInscriptions: function() {
      this.inscriptions = !this.inscriptions;
    },
    // 清除 input 框
    clearInput: function(type) {
      if (type === "wxinputName") {
        this.WeChatData.account.text = "";
      }
      if (type === "wxInputPwd") {
        this.WeChatData.password.code = "";
      }
      if (type === "wxInputHotelInputKye") {
        this.HotelInputKye = "";
      }
      if (type === "inputName") {
        this.formData.account.account.text = "";
        this.formData.account.account.close = false;
      }
      if (type === "inputPwd" || type === "inputPwdt") {
        this.formData.account.password.code = "";
      }
      if (type === "inputPhone") {
        this.formData.cellPhone.phone.text = "";
      }
      if (type === "inputPhoneCode") {
        this.formData.cellPhone.mobileCode.code = "";
        this.formData.cellPhone.mobileCode.close = false;
      }
      if (type === "inputHotelAcaear") {
        this.HotelInputKye = "";
      }
      this.$nextTick(() => {
        if (type === "inputName") {
          this.$refs.inputNameRef.focus();
        }
        if (type === "inputPwd") {
          this.$refs.inputPwdRef.focus();
        }
        if (type === "inputPwdt") {
          this.$refs.inputPwdReft.focus();
        }
        if (type === "inputPhone") {
          this.$refs.inputPhoneRef.focus();
        }
        if (type === "inputPhoneCode") {
          this.$refs.inputPhoneCodeRef.focus();
        }
        if (type === "inputHotelAcaear") {
          this.$refs.nameHotelListRef.focus();
          this.Hotels = this.seldectHoteBackups;
        }
      });
    },
    nextPageTage: function() {
      window.location.replace(
        `signin?ReturnUrl=${encodeURIComponent(this.ReturnUrl)}`
      );
    },
    // 找回密码
    nextPage: function() {
      window.location.replace(
        `/AccountLogin/ForgetPass?ReturnUrl=${encodeURIComponent(
          this.ReturnUrl
        )}`
      );
      // window.location = `/Login/ForgetPass?ReturnUrl=${
      //   document.getElementById("ReturnUrl").value
      // }`;
    },
    /**
     * 登录方式切换
     */
    onSweepTheLoginCode: function() {
      this.loginMethod.sweepTheLoginCode = !this.loginMethod.sweepTheLoginCode;

      if (!this.loginMethod.sweepTheLoginCode) {
        // 普通登录 true:普通登录   false:验证吗登录
        const name = this.formData.account.account.text.trim();
        const phone = this.formData.cellPhone.phone.text.trim();
        if (this.loginMethod.isOnWay && name !== "") {
          this.$refs.inputNameRef.focus();
          this.getHotelListFn(1);
        } else if (!this.loginMethod.isOnWay && phone !== "") {
          this.$refs.inputPhoneRef.focus();
          this.getHotelListFn(2);
        }
      } else {
        const isWX = this.loginMethodSwitch.indexOf(3) != -1;
        const isQyWX = this.loginMethodSwitch.indexOf(4) != -1;
        const isDD = this.loginMethodSwitch.indexOf(6) != -1;
        const fyBook = this.loginMethodSwitch.indexOf(9) != -1;
        console.log(this.loginMethodSwitch);
        if (isWX) {
          this.wexingType.type = 3;
          return;
        }
        if (isQyWX) {
          this.wexingType.type = 4;
          return;
        }
        if (isDD) {
          this.wexingType.type = 6;
        }
        if (fyBook) {
          this.wexingType.type = 9;
        }
      }
    },
    /**
     * 点击其他地方 隐藏 下拉框
     */
    exclusive: function() {
      this.loginMethod.isPullDownHotel = false;
    },
    /**
     * 登录 方式切换
     */
    onTrigger: function() {
      const _self = this;

      if (_self.loginMethodSwitch.indexOf(2) == -1) {
        return;
      }
      _self.resetpasswords9 = false;
      _self.formData.account.account.err = false;
      _self.formData.cellPhone.phone.err = false;
      this.loginMethod.isOnWay = !this.loginMethod.isOnWay;
      if (!this.loginMethod.sweepTheLoginCode) {
        this.selectHotel = null;
        // 普通登录 true:普通登录   false:验证吗登录
        const name = this.formData.account.account.text.trim();
        const phone = this.formData.cellPhone.phone.text.trim();
        clearTimeout(_self.timer_timeout);
        _self.timer_timeout = null;
        _self.timer_timeout = setTimeout(function() {
          if (_self.loginMethod.isOnWay && name !== "") {
            _self.getHotelListFn(1);
          } else if (!_self.loginMethod.isOnWay && phone !== "") {
            _self.getHotelListFn(2);
          }
        }, 500);
      }
    },
    /**
     * 酒店列表
     */
    onChangePullDown: function() {
      if (this.Hotels.length > 0) {
        this.loginMethod.isPullDownHotel = !this.loginMethod.isPullDownHotel;
      }
    },
    /**
     * 选择酒店
     */
    checkedHotel: function(item) {
      this.selectHotel = item;
      this.HotelInputKye = `${item.HotelCd}  ${item.HotelName}`;
      this.loginMethod.isPullDownHotel = !this.loginMethod.isPullDownHotel;

      this.$nextTick(function() {
        if (!this.loginMethod.sweepTheLoginCode) {
          // 普通登录 true:普通登录   false:验证吗登录
          this.$refs.nameLogin.focus();
        } else {
          this.$refs.wxlongBtn.focus();
        }
      });
    },
    /**
     * 搜索酒店
     */
    searchHotels: function(e) {
      const _self = this;
      this.loginMethod.isPullDownHotel = true;
      if (_self.HotelInputKye === e.target.value) return;
      _self.HotelInputKye = e.target.value;
      if (_self.selectHotel === null) {
        return;
      }
      if (_self.HotelInputKye.trim() === "") {
        return [];
      }
      const inputKey = _self.HotelInputKye.toUpperCase();
      const hotels = _self.seldectHoteBackups.filter(function(item) {
        return item.HotelCd.indexOf(inputKey) !== -1;
      });
      _self.Hotels = hotels;
    },

    /**
     * 点击登录  超过一定次数 显示验证码 点击获取图新验证
     */
    btnClick: async function() {
      const _self = this;
      if (!this.loginMethod.sweepTheLoginCode) {
        // 普通登录 true:普通登录   false:验证吗登录
        if (this.loginMethod.isOnWay) {
          const name = this.formData.account.account.text;
          const pwd = this.formData.account.password.code;
          if (name === "") {
            this.formData.account.account.err = true;
            this.formData.account.account.msg = "请输入您的账号";
            return false;
          }
          if (pwd === "") {
            this.formData.account.password.err = true;
            this.formData.account.password.msg =
              "请输入域密码/PMS密码/首旅密码";
            return false;
          }
        } else if (!this.loginMethod.isOnWay) {
          const phone = this.formData.cellPhone.phone.text;
          const code = this.formData.cellPhone.mobileCode.code.trim();
          if (phone === "") {
            this.formData.cellPhone.phone.err = true;
            this.formData.cellPhone.phone.msg = "请输入您的手机号";
            return false;
          }
          const isPhone = await isCellPhoneNumber(phone);
          if (isPhone) {
            this.formData.cellPhone.phone.err = true;
            this.formData.cellPhone.phone.msg = "请输入正确的手机号";
            return false;
          }
          if (code === "") {
            this.formData.cellPhone.mobileCode.err = true;
            this.formData.cellPhone.mobileCode.msg = "请输入您的验证码";
            return false;
          }
        }
      }
      // 如果有缓存数据
      if (!this.isHotels) {
        this.getHotelListFn(1);
        return false;
      }
      if (this.btnIsGt) {
        this.isgt = !this.isgt;
      } else {
        this.logonfn();
      }
    },
    /**
     * 绑定微信
     */
    webChatBnClick: async function() {
      const _self = this;
      const name = this.WeChatData.account.text;
      const pwd = this.WeChatData.password.code;
      if (name === "") {
        this.WeChatData.account.err = true;
        this.WeChatData.account.msg = "请输入您的账号";
        return;
      }
      if (pwd === "") {
        this.WeChatData.password.err = true;
        this.WeChatData.password.msg = "请输入域密码/PMS密码/首旅密码";
        return;
      }
      // 如果有缓存数据
      if (!this.isHotels) {
        this.getHotelListFn(1);
        return;
      }
      if (this.btnIsGt) {
        this.isgt = !this.isgt;
      } else {
        this.webChatfn();
      }
    },

    /**
     * 极验图片加载之后，通过更改控制变量实现可以再次加载
     */
    GeetChange: function(val) {
      this.isgt = val;
    },

    GeetPath: function(val) {
      this.isgt = false;
      if (this.wxHotels) {
        this.webChatfn(val);
      } else {
        this.logonfn(val);
      }
    },
    /**
     *  取消用户名 错误提示
     */
    nameFouse: function() {
      const name = this.formData.account.account.text;
      const oldName = this.formData.account.account.oldText.trim();
      this.formData.account.account.err = false;
      if (!name) {
        this.formData.account.account.close = false;
      } else {
        this.formData.account.account.close = true;
        // this.formData.account.account.oldText = name;
      }
    },
    /**
     *用户名失去焦点 是否价值酒店列表
     */
    nameBlur: async function(e) {
      const _self = this;
      const name = this.formData.account.account.text.trim();
      const oldName = this.formData.account.account.oldText.trim();
      if (name === "") {
        _self.formData.account.account.err = true;
        _self.formData.account.account.msg = "请输入您的账号";
        return;
      }
      _self.$nextTick(function() {
        setTimeout(function() {
          _self.formData.account.account.close = false;
        }, 200);
      });
      if (name === oldName) {
        return;
      }
      _self.formData.account.account.oldText = name;
      _self.formData.account.account.err = false;
      _self.formData.account.account.msg = "";

      clearTimeout(_self.timer_timeout);
      _self.timer_timeout = null;
      _self.timer_timeout = setTimeout(function() {
        _self.getHotelListFn(1);
        _self.timer_timeout = null;
      }, 500);
    },
    /**
     *  wx 用户名 错误提示
     */
    wechatNameFouse: function() {
      const name = this.WeChatData.account.text;
      this.WeChatData.account.err = false;
      if (!name) {
        this.WeChatData.account.oldText = name;
      }
      // this.formData.account.account.err = false;
    },
    /**
     * 用户名失去焦点 是否价值酒店列表
     */

    wechatNameBlur: async function(e) {
      const _self = this;
      const name = this.WeChatData.account.text.trim();
      const oldName = this.WeChatData.account.oldText.trim();
      if (name === "") {
        this.WeChatData.account.err = true;
        this.WeChatData.account.msg = "请输入您的账号";
        return;
      }
      if (name === oldName) {
        return;
      }
      this.WeChatData.account.oldText = name;
      this.WeChatData.account.err = false;
      this.WeChatData.account.msg = "";
      clearTimeout(_self.timer_timeout);
      _self.timer_timeout = null;
      _self.timer_timeout = setTimeout(function() {
        _self.getHotelListFn(1);
        _self.timer_timeout = null;
      }, 500);
    },
    /**
     *  用户名登录是否输入密码
     */
    namePwdFouse: function() {
      const userPwd = this.formData.account.password.code;
      this.formData.account.password.err = false;
      if (!userPwd) {
        this.formData.account.password.close = false;
      } else {
        this.formData.account.password.close = true;
      }
      // this.formData.account.account.err = false;
    },
    /**
     * 用户名 密码失去 焦点
     */
    namePwdBlur: function() {
      const _self = this;
      const name = this.formData.account.account.text;
      const pwd = this.formData.account.password.code;
      if (name === "") {
        this.formData.account.account.err = true;
        this.formData.account.account.msg = "请输入您的账号";
      }
      if (pwd === "") {
        this.formData.account.password.err = true;
        this.formData.account.password.msg = "请输入域密码/PMS密码/首旅密码";
      }
      this.formData.account.password.err = false;
      this.formData.account.password.msg = "";
      _self.$nextTick(function() {
        setTimeout(function() {
          _self.formData.account.password.close = false;
        }, 200);
      });
    },

    wechatNamePwdFouse: function() {
      this.WeChatData.password.err = false;
      // this.formData.account.account.err = false;
    },
    /**
     * 用户名 密码失去 焦点
     */
    wechatNamePwdBlur: function() {
      const _self = this;
      const name = this.WeChatData.account.text;
      const pwd = this.WeChatData.password.code;
      if (name === "") {
        this.WeChatData.account.err = true;
        this.WeChatData.account.msg = "请输入您的账号";
        return;
      }
      if (pwd === "") {
        this.WeChatData.password.err = true;
        this.WeChatData.password.msg = "请输入域密码/PMS密码/首旅密码";
        return;
      }
      this.WeChatData.password.err = false;
      this.WeChatData.password.msg = "";
    },
    /**
     *  取消手机验错误提示
     */
    phoneFouse: function() {
      this.formData.cellPhone.phone.err = false;
      const pshone = this.formData.cellPhone.phone.text;
      if (!pshone) {
        this.formData.cellPhone.phone.close = false;
      } else {
        this.formData.cellPhone.phone.close = true;
      }
      // this.formData.account.account.err = false;
    },
    /**
     * 手机号失去焦点 是否价值酒店列表
     */
    phoneBlur: async function() {
      const _self = this;
      const phone = this.formData.cellPhone.phone.text;
      // if (phone === "") {
      //   this.formData.cellPhone.phone.err = true;
      //   this.formData.cellPhone.phone.msg = "请输入您的手机号";
      //   return;
      // }
      _self.$nextTick(function() {
        setTimeout(function() {
          _self.formData.cellPhone.phone.close = false;
        }, 200);
      });
      const isPhone = await isCellPhoneNumber(phone);
      if (isPhone) {
        this.formData.cellPhone.phone.err = true;
        this.formData.cellPhone.phone.msg = "请输入正确的手机号";
        return;
      }
      this.formData.cellPhone.phone.err = false;
      this.formData.cellPhone.phone.msg = "";
      // clearTimeout(_self.timer_timeout);
      // _self.timer_timeout = null;
      // _self.timer_timeout = setTimeout(function () {
      //   _self.getHotelListFn(2);
      //   clearTimeout(_self.timer_timeout);
      //   _self.timer_timeout = null;
      // }, 500);
    },
    /**
     *  手机 取消验证码误提示
     */
    phoneCodeFouse: function() {
      this.formData.cellPhone.mobileCode.err = false;
      const pshoneCode = this.formData.cellPhone.mobileCode.code;
      if (!pshoneCode) {
        this.formData.cellPhone.mobileCode.close = false;
      } else {
        this.formData.cellPhone.mobileCode.close = true;
      }
      // this.formData.account.account.err = false;
    },
    /**
     * 验证码失去焦点 是否酒店列表
     */
    phoneCodeBlur: async function() {
      const _self = this;
      const code = this.formData.cellPhone.mobileCode.code;
      const phone = this.formData.cellPhone.phone.text;
      _self.$nextTick(function() {
        setTimeout(function() {
          _self.formData.cellPhone.mobileCode.close = false;
        }, 200);
      });
      if (phone === "") {
        this.formData.cellPhone.phone.err = true;
        this.formData.cellPhone.phone.msg = "请输入您的手机号";
        return;
      }
      const isPhone = await isCellPhoneNumber(phone);
      if (isPhone) {
        this.formData.cellPhone.phone.err = true;
        this.formData.cellPhone.phone.msg = "请输入正确的手机号";
        return;
      }
      if (code === "") {
        this.formData.cellPhone.mobileCode.err = true;
        this.formData.cellPhone.mobileCode.msg = "请输入短信验证码";
        return;
      }

      this.formData.cellPhone.mobileCode.err = false;
      this.formData.cellPhone.mobileCode.msg = "";
    },
    /**
     * 验证码是否酒店列表
     */
    getMobileCode: async function() {
      const that = this;
      const phone = this.formData.cellPhone.phone.text;

      if (this.formData.cellPhone.wait_timer > 0) {
        return false;
      }
      if (phone === "") {
        this.formData.cellPhone.phone.err = true;
        this.formData.cellPhone.phone.msg = "请输入您的手机号";
        return false;
      }

      const isPhone = await isCellPhoneNumber(phone);
      if (isPhone) {
        this.formData.cellPhone.phone.err = true;
        this.formData.cellPhone.phone.msg = "请输入正确的手机号";
        return false;
      }

      const params = {
        Mobile: phone,
        type: 6
        // Type: 3,
      };

      // 点击 验证码获取酒店列表
      clearTimeout(that.timer_timeout);
      that.timer_timeout = null;
      that.timer_timeout = setTimeout(function() {
        that.getHotelListFn(2);
        clearTimeout(that.timer_timeout);
        that.timer_timeout = null;
      }, 500);

      const phoneKey = await this.$http.getPhoneSendKey(params);
      const getPhoneCode = Number(phoneKey.Code);
      if (getPhoneCode !== 200) {
        that.timer_interval = null;
        that.formData.cellPhone.phone.err = true;
        that.formData.cellPhone.phone.msg = phoneKey.Msg;
        // if (that.timer_interval) {
        //   clearInterval(that.timer_interval);
        //   that.formData.cellPhone.wait_timer = 0;
        //   that.getMobileCodeText();
        // }
        return false;
      }

      this.formData.cellPhone.wait_timer = 59;
      that.timer_interval = setInterval(function() {
        if (that.formData.cellPhone.wait_timer > 0) {
          that.formData.cellPhone.wait_timer--;
        } else if (that.formData.cellPhone.wait_timer <= 0) {
          clearInterval(that.timer_interval);
          that.timer_interval = null;
        }
      }, 1000);

      // 在这里调取你获取验证码的ajax
    },
    getMobileCodeText: function() {
      if (this.formData.cellPhone.wait_timer > 0) {
        return this.formData.cellPhone.wait_timer + "s";
      }

      if (this.formData.cellPhone.wait_timer === 0) {
        return "重新获取";
      }

      if (this.formData.cellPhone.wait_timer === false) {
        return "获取验证码";
      }
    },
    // 登录
    logonfn: async function(val) {
      const _self = this;
      let geetest = null;
      let name = {
        UserId: "",
        Pwd: ""
      };
      const pmReturnUrl = this.ReturnUrl;
      const pmHotelCd =
        this.selectHotel !== null ? this.selectHotel.HotelCd : "";
      const pmHotelname =
        this.selectHotel !== null && this.selectHotel.length > 0
          ? `${this.selectHotel.HotelCd}  ${this.selectHotel.HotelName}`
          : "";

      let params = {
        ReturnUrl: pmReturnUrl,
        HotelCd: pmHotelCd,
        hotelname: pmHotelname
      };
      if (!this.loginMethod.sweepTheLoginCode) {
        // 普通登录 true:普通登录   false:验证吗登录
        if (this.loginMethod.isOnWay) {
          name = {
            UserId: this.formData.account.account.text.trim(),
            Pwd: this.formData.account.password.code.trim(),
            LoginType: "pwd"
          };
          if (name.UserId === "" || name.Pwd === "") {
            return false;
          }
        } else {
          name = {
            Mobile: this.formData.cellPhone.phone.text.trim(),
            Pwd: this.formData.cellPhone.mobileCode.code.trim(),
            LoginType: "sms"
          };
          if (name.Mobile === "" || name.Pwd === "") {
            return false;
          }
        }
      } else {
        name = {
          UserId: this.UserId,
          OpenId: this.OpenId,
          Code: this.Code,
          LoginType: this.LoginType
        };
      }
      if (val) {
        geetest = {
          geetest_challenge: val.geetest_challenge,
          geetest_seccode: val.geetest_seccode,
          geetest_validate: val.geetest_validate
        };
        params = Object.assign(params, geetest);
      }
      params = Object.assign(params, name);

      // const paramsFormData = new FormData();
      // Object.keys(params).forEach(key => {
      //   paramsFormData.append(key, params[key]);
      // });
      const login = await this.$http.postLogin(params);
      const loginCode = Number(login.Code);
      const loginMemo = Number(login.Memo);
      // 是否需要验证码
      if (loginMemo === -1) {
        this.currentCom = Geet;
        _self.btnIsGt = true;
      }
      if (loginCode === 301) {
        self.resetpasswords9 = false;
        _self.formData.account.account.err = true;
        _self.formData.account.account.msg = login.Msg;
        const _url = `${login.Data.UpdatePwdUrl}`;
        _self.resetpasswords9 = true;
        _self.resetpasswordsurl = _url;
        return false;
        // _self.getHotelListFn(1); // 验证码输入次数   是否需要验证码
      }

      if (loginCode === 200) {
        window.location.replace(login.Data.LoginSuccessReturnUrl);
      } else {
        // this.loginErrorNumber = this.loginErrorNumber + 1;
        if (name.LoginType === "pwd") {
          _self.formData.account.account.msg = login.Msg;
          _self.formData.account.account.err = true;
        } else if (name.LoginType === "sms") {
          _self.formData.cellPhone.phone.err = true;
          _self.formData.cellPhone.phone.msg = login.Msg;
        }
      }
    },
    // 绑微信
    webChatfn: async function(val) {
      const _self = this;
      let geetest = null;
      // const pmReturnUrl = document.getElementById("hidReturnUrl").value;
      // // const pmSignin = document.getElementById("signin").value; hidOpenId
      // const LoginType = document.getElementById("hidLoginType").value;
      const pmHotelCd =
        _self.selectHotel !== null ? _self.selectHotel.HotelCd : "";
      const pmHotelname =
        _self.selectHotel !== null && _self.selectHotel.length > 0
          ? `${_self.selectHotel.HotelCd}  ${_self.selectHotel.HotelName}`
          : "";
      let params = {
        HotelCd: pmHotelCd,
        // SecretKey: this.SecretKey,
        // MacKey: this.MacKey,
        // IServerVersion: this.IServerVersion,
        hotelname: pmHotelname,
        UserId: _self.WeChatData.account.text.trim(),
        Pwd: _self.WeChatData.password.code.trim(),
        Code: _self.Code,
        OpenId: _self.OpenId,
        LoginType: _self.LoginType
      };
      if (val) {
        geetest = {
          geetest_challenge: val.geetest_challenge,
          geetest_seccode: val.geetest_seccode,
          geetest_validate: val.geetest_validate
        };
        params = Object.assign(params, geetest);
      }

      // const paramsFormData = new FormData();
      // Object.keys(params).forEach(key => {
      //   paramsFormData.append(key, params[key]);
      // });
      const bindLoginRes = await _self.$http.bindingWx(params);
      const bindCode = Number(bindLoginRes.Code);
      if (bindCode === 200) {
        // window.location.replace(bindLoginRes.Data.ReturnUrl);
        // 绑定完成以后直接 调用登陆接口
        const logparams = {
          HotelCd: pmHotelCd,
          UserId: bindLoginRes.Data.UserId,
          Code: _self.Code,
          OpenId: _self.OpenId,
          LoginType: _self.LoginType,
          ReturnUrl: _self.ReturnUrl
        };
        const wxLogin = await _self.$http.postLogin(logparams);
        const wxLoginCode = Number(wxLogin.Code);
        if (wxLoginCode == 200) {
          window.location.replace(wxLogin.Data.LoginSuccessReturnUrl);
        } else {
          _self.WeChatData.account.err = true;
          _self.WeChatData.account.msg = wxLogin.Msg;
        }
      } else {
        _self.WeChatData.account.err = true;
        _self.WeChatData.account.msg = bindLoginRes.Msg;
      }
    },
    // 酒店列表  _self.isHotels
    getHotelListFn: async function(type) {
      const _self = this;
      this.HotelInputKye = "";
      this.selectHotel = null;
      this.seldectHoteBackups = null;
      this.Hotels = [];
      // type 1 用户名   2 手机号  3 微信
      let name = this.formData.account.account.text.trim();
      let params = {
        UserId: name.trim(),
        LoginType: "pwd"
      };

      // @*0 非联合登入 1联合登入未绑定 2联合登入无酒店 3联合登入有酒店*@
      const wxLogin = Number(document.getElementById("hidIsUnionLogin").value);
      // type 1 用户名   2 手机号  3 微信
      if (wxLogin === 1) {
        name = _self.WeChatData.account.text.trim();
        // 绑定wx
        params = {
          UserId: name,
          LoginType: "pwd"
        };
      } else if (wxLogin === 2 || wxLogin === 3) {
        // wx 登陆

        params = {
          UserId: _self.UserId,
          LoginType: "pwd"
          // LoginType: "wx",
        };
      }
      if (type === 2) {
        const phone = this.formData.cellPhone.phone.text.trim();
        if (phone === "") {
          return;
        }
        params = {
          Mobile: phone,
          LoginType: "sms"
        };
      }
      // 绑定微信加载酒店
      if (type === 3) {
        params = {
          UserId: this.UserId,
          LoginType: "pwd"
          // LoginType: "wx",
        };
      }
      // if (type === 4) {
      //   params = {
      //     UserId: this.UserId,
      //     LoginType: "pwd",
      //     // LoginType: "qywx",
      //   };
      // }
      _self.lodingShow = true; // lodikng
      const resHotels = await this.$http.getTheHotelList(params);
      const resultCode = Number(resHotels.Code);
      const resultMemo = Number(resHotels.Memo); // 判断用户密码是否已经过期
      _self.lodingShow = false; // loading
      _self.isHotels = true;
      // 是否需要验证码
      if (resultMemo === -1) {
        this.currentCom = Geet;
        _self.btnIsGt = true;
      }
      if (resultCode === 200) {
        if (
          resHotels.Data &&
          resHotels.Data.Hotels &&
          resHotels.Data.Hotels.length > 0
        ) {
          _self.Hotels = resHotels.Data.Hotels;
          _self.seldectHoteBackups = resHotels.Data.Hotels;
          // this.seldectHoteBackups = this._.clone(this.Hotels, true);
          _self.selectHotel = resHotels.Data.Hotels[0];
          _self.HotelInputKye = `${_self.selectHotel.HotelCd}  ${_self.selectHotel.HotelName}`;
        } else if (
          resHotels.Data &&
          resHotels.Data.Hotels != null &&
          resHotels.Data.Hotels.length <= 1 &&
          wxLogin === "3"
        ) {
          // 如果没有酒店或者只有一家酒店 直接登陆
          _self.btnClick();
          return false;
        } else {
          _self.selectHotel = null;
          // console.table(resHotels);
        }
        // _self.$nextTick(function () {
        //   if (type === 2 || type === 1) {
        //     this.$refs.nameLogin.focus();
        //   } else if (type === 3) {
        //     this.$refs.wxlongBtn.focus();
        //   }
        // });
      } else {
        if (type === 2) {
          _self.formData.cellPhone.phone.err = true;
          _self.formData.cellPhone.phone.msg = resHotels.Msg;
          clearInterval(_self.timer_interval);
          _self.formData.cellPhone.wait_timer = 0;
          _self.getMobileCodeText();
        }
        if (type === 1) {
          _self.formData.account.account.msg = resHotels.Msg;
          _self.formData.account.account.err = true;
          _self.resetpasswords9 = false;
          return false;
        }
      }

      // 密码 14-4 天之间过期提醒
      if (resultMemo >= 76 && resultMemo < 90) {
        if (!_self.wxHotels) {
          const overdueCount = 90 - resultMemo;
          // _self.formData.account.password.err = true;
          // _self.formData.account.password.msg = `您的密码还有 ${overdueCount} 天过期`;
          const _url = `/AccountLogin/ForgetPass?ReturnUrl=${encodeURIComponent(
            _self.ReturnUrl
          )}`;
          _self.resetpasswordsurl = _url;
          _self.formData.account.account.msg = `您的密码还有 ${overdueCount} 天过期`;
          _self.formData.account.account.err = true;
          _self.resetpasswords9 = true;
        }
      } else if (resHotels.Data != null && resultMemo >= 90) {
        // 您的密码已经过期，请立即
        if (!_self.wxHotels) {
          // const _ReturenUrl = document.getElementById("hidReturnUrl").value;
          const _url = `/AccountLogin/ForgetPass?ReturnUrl=${encodeURIComponent(
            _self.ReturnUrl
          )}`;
          _self.resetpasswordsurl = _url;
          _self.formData.account.account.msg = `您的密码已经过期，请立即修改`;
          _self.formData.account.account.err = true;
          _self.resetpasswords9 = true;
          // _self.formData.account.password.err = true;
          // _self.formData.account.password.msg = `您的密码已经过期，请立即修改`;
        }
      }
    },
    // IE低版本提示
    getIeVersion: function() {
      const userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
      const isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; // 判断是否IE<11浏览器
      const isEdge = userAgent.indexOf("Edge") > -1 && !isIE; // 判断是否IE的Edge浏览器
      const isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
      if (isIE) {
        const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        const fIEVersion = parseFloat(RegExp.$1);
        if (fIEVersion === 7) {
          return 7;
        } else if (fIEVersion === 8) {
          return 8;
        } else if (fIEVersion === 9) {
          return 9;
        } else if (fIEVersion === 10) {
          return 10;
        } else {
          return 6; // IE版本<=7
        }
      } else if (isEdge) {
        return "edge"; // edge
      } else if (isIE11) {
        return 11; // IE11
      } else {
        return -1; // 不是ie浏览器
      }
    }
  },
  created() {
    // 有参数 微信扫码回调
    this.$nextTick(function() {
      this.getHomeImgList();
      const _self = this;
      const IE = _self.getIeVersion();
      const token = document.getElementById("hidRequestVerificationToken")
        .value;
      const loadViewType = document.getElementById("hidIsUnionLogin").value;
      const UserId = document.getElementById("hidUserId").value;
      const OpenId = document.getElementById("hidOpenId").value;
      const code = document.getElementById("hidCode").value;
      const ReturnUrl = document.getElementById("hidReturnUrl").value;
      const LoginType = document.getElementById("hidLoginType").value;
      const sessionReturn = sessionStorage.getItem("_returnurl");
      // hidSupportLoginTypes  // 竖线分割 1=密码登入 2=短信登入 3=个人微信 4=企微登入 6=钉钉登入  9=飞书扫码登陆
      const loginMethodSwitch = document.getElementById("hidSupportLoginTypes")
        .value;
      // 微信扫码登陆时 returnurl 为空 获取 sessionStroe 里的 returnurl
      this.token = token;
      const catchReturnUrl = ReturnUrl === "" ? sessionReturn : ReturnUrl;
      this.LoginType = LoginType;
      this.UserId = UserId;
      this.OpenId = OpenId;
      this.Code = code;
      // 参数类型不需要编码 只有 a标签跳转的需要  Url 跳转 需要编码
      this.ReturnUrl = catchReturnUrl;
      this.loginMethodSwitch = loginMethodSwitch.split("|").map(Number);
      this.wxstate = token;

      if (ReturnUrl !== "") {
        window.sessionStorage.setItem("_returnurl", ReturnUrl);
      }
      if (IE < 10 && IE > 0) {
        let x;
        const r = confirm(
          "您的游览器版本过低 部分功能将不可用，请升级您的浏览器!"
        );
        if (r == true) {
          x = '"确定"按钮!';
          window.location.replace("https://sso.cloudhotels.cn/Download.html");
          // window.location = "https://sso.cloudhotels.cn/Download.html";
        } else {
          x = '"取消"按钮!';
        }
      }

      // @*0 非联合登入 1联合登入未绑定 2联合登入无酒店 3联合登入有酒店*@
      if (loadViewType == 1) {
        this.wxHotels = true;
        this.$refs.wxInputName.focus();
        if (!this.WeChatData.account.text) {
          this.getHotelListFn(1);
        }
      }
      // if (loadViewType == 2) {
      //   this.wxHotelsShow = true;
      //   // this.getHotelListFn(1);
      // }
      if (loadViewType == 3) {
        this.loginMethodSwitch = [1];
        this.wxHotelsShow = true;
        // 微信 酒店列表
        this.getHotelListFn(3);
        this.loginMethod.wx = false;
        this.loginMethod.sweepTheLoginCode = !this.loginMethod
          .sweepTheLoginCode;
      }
      // 手机号登录
      if (this.loginMethodSwitch.indexOf(2) != -1) {
        this.loginMethodSwitch.push(2);
      }

      // ws yqwx dd fs 绑定 选择酒店默认选择
      if (this.LoginType == "wx") {
        this.wexingType.type = 3;
        this.loginMethodSwitch.push(3);
      }
      if (this.LoginType == "qywx") {
        this.wexingType.type = 4;
        this.loginMethodSwitch.push(4);
      }
      if (this.LoginType == "dd") {
        this.wexingType.type = 6;
        this.loginMethodSwitch.push(6);
      }
      if (this.LoginType == "fs") {
        this.wexingType.type = 9;
        this.loginMethodSwitch.push(9);
      }
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@css/style.scss";

[v-cloak] {
  display: none;
}
.app-warp {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.home {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100%;

  /* display: flex;
  flex-direction: column;
  min-height: 100vh; */

  .content-warp {
    position: relative;
    display: flex;
    /* flex-grow: 1; */
    /* max-height: calc(100vh - 115px); */
    overflow: hidden;
    min-height: 500px;
    max-width: 100%;
    min-width: 1200px;
  }

  .interlinkage {
    height: 12px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(77, 151, 255, 1);
    line-height: 24px;
    text-decoration: none;
    display: inherit;
    float: right;
  }

  .normal-item {
    position: relative;
    margin-bottom: 24px;
    display: flex;

    .normal-phone-code {
      display: flex;
      justify-content: space-between;
    }

    .normal-phone-code-button {
      min-width: 100px;
      height: 44px;
      border: 1px solid #dddddd;
      border-radius: 0 2px 2px 0;
      border-left: 0;
      background: rgba(249, 249, 249, 1);
      color: rgba(64, 64, 64, 1);
    }
  }

  .normal-item:hover {
    input {
      border-color: #5c98ff;
    }
  }

  input:focus {
    border-color: #5c98ff;
    outline: 0;
    box-shadow: 0 0 0 2px rgba(51, 126, 255, 0.2);
    border-right-width: 1px !important;
  }

  input {
    width: 100%;
    height: 44px;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    box-sizing: border-box;
    padding-left: 39px;
    font-size: 14px;
  }

  .hotel {
    position: relative;

    .hotel-list {
      box-sizing: border-box;
      position: absolute;
      top: 53px;
      left: 0px;
      width: 297px;
      border: 1px solid #ddd;
      margin: 0 auto;
      z-index: 9999;
      color: #666;
      text-align: left;
      background-color: #fff;
      cursor: pointer;

      ul {
        overflow-y: auto;
        box-sizing: border-box;
        max-height: 180px;
      }

      .hotel-list-item {
        font-size: 14px;
        color: #666;
        text-align: left;
        border: none;
        padding: 12px 0px 12px 10px;
        cursor: pointer;

        span {
          padding-right: 10px;
        }
      }

      .hotel-list-item:hover {
        background-color: #f7f7f7;
      }
    }

    .hotel-list:before {
      content: "";
      position: absolute;
      top: -11px;
      left: 5px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #ddd;
    }

    .hotel-list:after {
      content: "";
      position: absolute;
      top: -9.5px;
      left: 5.5px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
    }
  }
}

.WeChat-binding {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;

  .binding-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .wxBindclearInput {
      right: 37px;
    }

    .binding {
      width: 500px;
      padding-bottom: 35px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);

      .binding-header {
        position: relative;
        width: 100%;
        height: 56px;
        line-height: 56px;
        background: rgba(245, 245, 245, 1);
        font-size: 18px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: center;
      }

      .binding-content {
        box-sizing: border-box;
        padding: 22px 105px 0;

        .binding-content-title {
          margin-bottom: 20px;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }
    }
  }
}

.login {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 使用css3的transform来实现 */
  width: 1200px;
  height: 0;
  min-width: 506px;
  z-index: 3000;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: hsla(0, 0%, 100%, 0);
  display: flex;
  justify-content: center;
  align-items: center;

  .login-warp {
    position: relative;
    left: -30px;
    box-sizing: border-box;
    width: 1200px;
    height: 0;
    min-width: 506px;
    background: rgba(255, 255, 255, 0);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .graph-validate {
      margin-bottom: 20px;

      .graph-validate-code {
        padding: 0 30px;
        font-size: 14px;
        width: 100%;
        height: 44px;
        line-height: 44px;
        background: -webkit-gradient(
          linear,
          right top,
          left top,
          from(#1af47e),
          to(#56f07e)
        );
        background: linear-gradient(-90deg, #1af47e, #56f07e);
        border-radius: 4px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #fefefe;
      }
    }

    // 扫码登录
    .code-login {
      /* margin-left: 800px; */
      min-width: 350px;
      height: 410px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      padding: 34px;
      background: #fff url("../../assets/img/icons/code-login-bg.png") no-repeat
        bottom center;
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      background-size: 355px auto;

      .code-login-title {
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 34px;
        line-height: 34px;
        margin-top: 20px;
        font-size: 18px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);

        button {
          padding: 0 8px;
          margin: 0 px;
        }

        .active {
          color: #4d97ff;
        }
      }

      .code-login-hint {
        height: 12px;
        margin-top: 25px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);

        span {
          color: #4d97ff;
        }
      }

      .qr-code-warp {
        img {
          width: 260px;
        }
      }
    }
  }
}

.normal-loding-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 52px;
  height: 52px;
  background: rgba(0, 0, 0, 0)
    url("../../assets/img/icons/normal-login-icon.png") no-repeat top right;
  background-size: 52px 52px;
  cursor: pointer;
}

.normal-loding-btn:hover {
  opacity: 0.8;
}

.code-login-btn {
  background: rgba(0, 0, 0, 0) url("../../assets/img/icons/code-login-ionc.png")
    no-repeat top right;
  background-size: 52px 52px;
}

.name-icon {
  background: #fff url("../../assets/img/icons/name-icon.png") no-repeat 10px
    center;
  background-size: 20px auto;
}

.password-icon {
  background: #fff url("../../assets/img/icons/password-icon.png") no-repeat
    10px center;
  background-size: 20px auto;
}

.hotel-icon {
  background: #fff url("../../assets/img/icons/hotel-icon.png") no-repeat 10px
    center;
  background-size: 20px auto;
  cursor: pointer;
  padding-right: 39px;
}

.phone-icon {
  background: #fff url("../../assets/img/icons/phone-icon.png") no-repeat 10px
    center;
  background-size: 20px auto;
}

.hotel:after {
  display: block;
  content: " ";
  position: absolute;
  width: 39px;
  height: 38px;
  right: 0;
  bottom: 0;
  background: url("../../assets/img/icons/row-dow.png") no-repeat 10px center;
  background-size: 20px auto;
  cursor: pointer;
}

// 普通登录
.normal-landing {
  /* margin-left: 800px; */
  width: 350px;
  min-height: 410px;
  box-sizing: border-box;
  position: relative;
  padding: 30px 34px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);

  &err {
    border: 1px solid rgba(250, 96, 96, 1);
  }

  .normal-table {
    margin-top: 4px;
    margin-bottom: 40px;
    padding-right: 20px;
    font-size: 18px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", SimSun, sans-serif;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    display: flex;
    justify-content: space-around;

    .tabbtn {
      height: 18px;
      font-size: 18px;
      cursor: pointer;
      color: rgba(51, 51, 51, 1);
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }

    .tabbtn.active {
      font-family: "Helvetica Neue", Helvetica, "PingFang SC",
        "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      cursor: pointer;
    }

    span {
      width: 1px;
      height: 22px;
      background: rgba(221, 221, 221, 1);
    }
  }
}

.err-icon {
  width: 16px;
  height: 16px;
  margin-right: 7px;
  background: url("../../assets/img/icons/err-iocn.png") no-repeat center top;
  background-size: 16px;
}

.err {
  position: absolute;
  top: -20px;
  line-height: 16px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.input-err {
  border: 1px solid rgba(250, 96, 96, 1) !important;
}

.weix-hotel {
  /* padding-top: 90px; */
  padding-top: 45px;
}

.close-model {
  width: 16px;
  height: 16px;
  margin-right: 7px;
  background: url("../../assets/img/icons/close-model.png") no-repeat center
    center;
  background-size: 16px;
}

.clearInput {
  position: absolute;
  top: 1px;
  right: 1px;
  width: 30px;
  height: 41px;
  background: url("../../assets/img/icons/clearInput.png") no-repeat center
    center;
  background-color: rgba(0, 0, 0, 0);
  background-size: 16px;
  cursor: pointer;
  z-index: 100;
}

.pwdtag-iocn {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 37px;
  height: 40px;
  background: url("../../assets/img/mobile/proclaimed.png") no-repeat center
    center;

  background-size: 20px auto;
  background-color: rgba(0, 0, 0, 0);
  cursor: pointer;
}

.proclaimed-iocn {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 37px;
  height: 40px;
  background: url("../../assets/img/mobile/pwd-icon.png") no-repeat center
    center;
  background-size: 20px auto;
  background-color: rgba(0, 0, 0, 0);
  cursor: pointer;
}
</style>
